/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { keyframes, css } from "@emotion/react";
import { AppDispatch, RootState } from "./../redux/store";
import { hideNotification, showNotification } from "../redux/notificationSlice";
interface NotificationProps {
  message: string;
  duration: number;
  isError: boolean;
}
const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
const animationStyle = css`
  ${fadeOut} 1s forwards
`;
const notificationStyle = (isVisible: boolean, isError: boolean) => css`
  position: fixed;
  bottom: 40px;
  right: 20px;
  background-color: ${!isError ? "#4caf50" : "red"};
  color: white;
  padding: 15px;
  border-radius: 5px;
  opacity: ${isVisible ? 1 : 0};
  z-index: 1000000;
  ${animationStyle}
`;

export const Notification = () => {
  const notification = useSelector((state: RootState) => state.notification);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (notification.isVisible) {
      const timer = setTimeout(() => {
        dispatch(hideNotification());
      }, notification.duration);

      return () => clearTimeout(timer);
    }
  }, [notification.message]);

  return (
    <div>
      {notification.message !== "" && (
        <div
          css={notificationStyle(notification.isVisible, notification.isError)}
        >
          {notification.message}
        </div>
      )}
    </div>
  );
};
